import { defineMessages } from 'react-intl';

export const wishlistMessages = defineMessages({
  toggle: {
    id: 'wishlist.linkSharer.toggle',
    defaultMessage: 'Zkopírovat odkaz na seznam',
  },
  header: {
    id: 'wishlist.linkSharer.header',
    defaultMessage: 'Podělte se o své oblíbené produkty',
  },
  shareLabel: {
    id: 'wishlist.linkSharer.label',
    defaultMessage: 'Odkaz ke sdílení:',
  },
  clipboard: {
    id: 'wishlist.linkSharer.clipboard',
    defaultMessage: 'Zkopírováno do schránky',
  },
  clipboardFail: {
    id: 'wishlist.linkSharer.clipboardFail',
    defaultMessage: 'Kopírování se nezdařilo, zkopírujte pomocí Ctrl+C',
  },
});
